import { render, staticRenderFns } from "./EditChangeManagerDialog.vue?vue&type=template&id=76dc3d12&"
import script from "./EditChangeManagerDialog.vue?vue&type=script&lang=js&"
export * from "./EditChangeManagerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports